module.exports = __webpack_public_path__ + "img/selected.97416dbc.svg";